import i18next from "i18next";
import { success, custom } from "./utilities";
import { downloadBase64File } from "../../system";
import { ToastifyService, instructorService } from "../../services";
import {
  contentType,
  adminActionConstants,
  instructorConstants,
  translationConstants,
  globalSystemConstants,
  loginConstants,
  freelanceInstructorConstants,
} from "../../constants";

const {
  INSTRUCTORS_DATA,
  INSTRUCTOR_DATA,
  VIEW_MODAL,
  SPOT_INSTRUCTORS_DATA,
  INSTRUCTOR_SPORTS,
  INSTRUCTOR_CENTER_DETAIL,
  GET_ALL_CENTER_INSTRUCTORS,
} = instructorConstants;

const {
  GET_APPROVAL_REQUESTED_INSTRUCTORS,
  GET_APPROVAL_REQUESTED_INSTRUCTOR_DATA_BY_ID,
} = adminActionConstants;

const getAllInstructors = (data) => {
  return (dispatch) => {
    dispatch(custom(INSTRUCTORS_DATA, globalSystemConstants.SPINNER_ACTIVATE));
    instructorService
      .getAllInstructors(data)
      .then(
        (response) => {
          const { page, pageData } = response;
          dispatch(success({ page, pageData }, INSTRUCTORS_DATA));
        },
        () =>
          ToastifyService.showError(i18next.t(translationConstants.noDataFound))
      )
      .finally(() => {
        dispatch(
          custom(INSTRUCTORS_DATA, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getInstructorById = (data) => {
  return (dispatch) =>
    instructorService.getInstructorById(data).then(
      (response) => dispatch(success(response, INSTRUCTOR_DATA)),
      () =>
        ToastifyService.showError(
          i18next.t(translationConstants.instructorNotFound)
        )
    );
};
const getInstructorsBySpotId = (spotId, data) => {
  return (dispatch) =>
    instructorService.getInstructorsBySpotId(spotId, data).then(
      (response) => dispatch(success(response, SPOT_INSTRUCTORS_DATA)),
      () =>
        ToastifyService.showError(
          i18next.t(translationConstants.instructorNotFound)
        )
    );
};
const toggleViewModal = (flag) => {
  return (dispatch) => dispatch(success(flag, VIEW_MODAL));
};

const getApprovalRequestedInstructors = (queryParams) => {
  return (dispatch) => {
    dispatch(
      custom(
        GET_APPROVAL_REQUESTED_INSTRUCTORS,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    instructorService
      .getApprovalRequestedInstructors(queryParams)
      .then((response) =>
        dispatch(success(response, GET_APPROVAL_REQUESTED_INSTRUCTORS))
      )
      .catch((error) =>
        ToastifyService.showError(i18next.t(translationConstants.noDataFound))
      )
      .finally(() => {
        dispatch(
          custom(
            GET_APPROVAL_REQUESTED_INSTRUCTORS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getApprovalRequestedInstructorById = (id) => {
  return (dispatch) => {
    dispatch(custom(INSTRUCTORS_DATA, globalSystemConstants.SPINNER_ACTIVATE));
    instructorService
      .getApprovalRequestedInstructorById(id)
      .then((response) =>
        dispatch(
          success(response, GET_APPROVAL_REQUESTED_INSTRUCTOR_DATA_BY_ID)
        )
      )
      .catch((error) => dispatch(toggleApprovalModal(false)))
      .finally(() => {
        dispatch(
          custom(INSTRUCTORS_DATA, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const toggleApprovalModal = (value) => {
  return (dispatch) => {
    dispatch(custom(value, instructorConstants.APPROVAL_MODAL));
  };
};

const approveInstructorDocuments = (data, gridState, userID) => {
  return (dispatch) => {
    dispatch(
      custom(
        GET_APPROVAL_REQUESTED_INSTRUCTORS,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    instructorService
      .approveInstructorDocuments(data)
      .then(() => {
        const message = i18next.t(
          translationConstants.userStateUpdateSuccessfully
        );
        ToastifyService.showSuccess(message);
        // dispatch(toggleApprovalModal(false));
        dispatch(getApprovalRequestedInstructorById(userID));
        dispatch(getApprovalRequestedInstructors(gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            GET_APPROVAL_REQUESTED_INSTRUCTORS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateInstructorStatusWithCallback = (data, callback) => {
  return (dispatch) => {
    dispatch(custom(INSTRUCTORS_DATA, globalSystemConstants.SPINNER_ACTIVATE));
    instructorService
      .updateInstructorStatus(data)
      .then((response) => {
        if (response) {
          dispatch(callback);
          dispatch(instructorActions.getInstructorById(data.userId));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(INSTRUCTORS_DATA, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const exportInstructorData = (gridState, requestType) => {
  return (dispatch) => {
    instructorService
      .exportInstructorData(gridState, requestType)
      .then((response) => {
        downloadBase64File(
          response.content,
          contentType.CSV,
          response.fileName
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

const getInstructorsSports = (spotId, data) => {
  return (dispatch) =>
    instructorService.getInstructorsSports(spotId, data).then(
      (response) => dispatch(success(response, INSTRUCTOR_SPORTS)),
      () =>
        ToastifyService.showError(
          i18next.t(translationConstants.instructorNotFound)
        )
    );
};

const becomeFreelancePayment = (checkout, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .becomeFreelancePayment(checkout)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const cancelMembership = (systemUserId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .cancelMembership(systemUserId)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const becomeFreelanceRePayment = (checkout, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .becomeFreelanceRePayment(checkout)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const becomeFreelanceWithSavedCard = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .becomeFreelanceWithSavedCard(data)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const becomeFreelanceWithSavedCardRepayment = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .becomeFreelanceWithSavedCardRepayment(data)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getFreelancerSportsDetail = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .getFreelancerSportsDetail(id)
      .then((response) => {
        dispatch(
          success(
            response,
            freelanceInstructorConstants.FREELANCE_INSTRUCTOR_SPORTS_DETAIL
          )
        );
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const updateFreelancerSportsDetail = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .updateFreelancerSportsDetail(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getInstructorCenterDetail = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .getInstructorCenterDetail(id)
      .then((response) => {
        dispatch(success(response, INSTRUCTOR_CENTER_DETAIL));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const toggleFreelanceModal = (flag) => {
  return (dispatch) =>
    dispatch(success(flag, freelanceInstructorConstants.FREELANCE_MODAL));
};

const getAllCenterInstructors = (data) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    instructorService
      .getAllCenterInstructors(data)
      .then((response) => {
        dispatch(success(response, GET_ALL_CENTER_INSTRUCTORS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const instructorActions = {
  toggleViewModal,
  getAllInstructors,
  getInstructorById,
  toggleApprovalModal,
  approveInstructorDocuments,
  getApprovalRequestedInstructors,
  updateInstructorStatusWithCallback,
  getApprovalRequestedInstructorById,
  exportInstructorData,
  getInstructorsBySpotId,
  getInstructorsSports,
  becomeFreelancePayment,
  becomeFreelanceWithSavedCard,
  getFreelancerSportsDetail,
  updateFreelancerSportsDetail,
  getInstructorCenterDetail,
  toggleFreelanceModal,
  getAllCenterInstructors,
  becomeFreelanceRePayment,
  becomeFreelanceWithSavedCardRepayment,
  cancelMembership,
};
